import TRANSLATION_ACCESSIBILITY_FI from './accessibility/translation';
import TRANSLATION_BOOKING_FI from './booking/translation';
import TRANSLATION_EVENTS_FI from './events/translation';
import TRANSLATION_EXPERIENCES_FI from './experiences/translation';
import TRANSLATION_FORM_FI from './form/translation';
import TRANSLATION_LANDING_PAGES_FI from './landingPages/translation';
import TRANSLATION_RESERVE_FI from './reserve/translation';
import TRANSLATION_SIGNIN_FI from './signin/translation';
import TRANSLATION_DATES_FI from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_FI,
  ...TRANSLATION_BOOKING_FI,
  ...TRANSLATION_DATES_FI,
  ...TRANSLATION_EVENTS_FI,
  ...TRANSLATION_EXPERIENCES_FI,
  ...TRANSLATION_FORM_FI,
  ...TRANSLATION_LANDING_PAGES_FI,
  ...TRANSLATION_RESERVE_FI,
  ...TRANSLATION_SIGNIN_FI,
};
